import type { Entity } from "../index"
import isEntityHasFloorElevation from "./isEntityHasFloorElevation"
import isEntityHasWaterElevation from "./isEntityHasWaterElevation"



export default function copyElevationMaybe(
  ent0: Entity,
  ent1: Entity
): void {
  if (isEntityHasFloorElevation(ent0) && isEntityHasFloorElevation(ent1)) {
    ent1.floor_e = ent0.floor_e
  }
  if (isEntityHasWaterElevation(ent0) && isEntityHasWaterElevation(ent1)) {
    ent1.water_e = ent0.water_e
  }
}
